import { useMemo } from 'react';

export const usePropertyPanelController = ({
  // State
  selectedNodes,
  activeNodes,
  prefabs,
  activeBreakpoint,
  effectiveBreakpoint,
  containerNode,
  settings,

  // Dimensions
  rootW,
  rootH,
  canvasRef,
  canvasScale,

  // Operations
  nodeOps,

  // Actions
  setSelectedNodeIds,
  setActiveBreakpoint,
  setViewportWidth,
  pushContext,
  clearSelection,

  // Functions
  getEditorSettings
}) => {
  const controller = useMemo(() => ({
    // Data
    selectedNodes,
    parentSize: { width: rootW, height: rootH },
    activeNodes,
    prefabs,
    activeBreakpoint,
    effectiveBreakpoint,
    settings: getEditorSettings(),
    containerNode,
    canvasRef,
    canvasScale,

    // Node Operations
    onChange: nodeOps.handlePropertyUpdate,
    onDelete: nodeOps.handleDelete,
    onSelect: setSelectedNodeIds,

    // Prefab Operations
    onMakePrefab: nodeOps.handleMakePrefab,
    onDetachPrefab: nodeOps.handleDetachPrefab,
    onUpdatePrefab: nodeOps.handleUpdatePrefab,
    onOpenPrefab: (prefabId) => {
      const prefab = prefabs.find((p) => p.id === prefabId);
      if (prefab && prefab.defaultWidth && prefab.defaultHeight) {
        pushContext(prefabId, prefab.defaultWidth, prefab.defaultHeight);
        clearSelection();
      }
    },

    // Responsive Operations
    onBreakpointChange: setActiveBreakpoint,
    onViewportWidthChange: setViewportWidth
  }), [
    selectedNodes,
    rootW,
    rootH,
    activeNodes,
    prefabs,
    activeBreakpoint,
    effectiveBreakpoint,
    containerNode,
    canvasRef,
    canvasScale,
    nodeOps,
    setSelectedNodeIds,
    setActiveBreakpoint,
    setViewportWidth,
    pushContext,
    clearSelection,
    getEditorSettings
  ]);

  return controller;
};
